export const SET_INTENDED_URL = "setIntendedUrl";
export const REMOVE_INTENDED_URL = "removeIntendedUrl";